import { render } from "./EditSetting.vue?vue&type=template&id=969e1ff8&scoped=true"
import script from "./EditSetting.vue?vue&type=script&lang=js"
export * from "./EditSetting.vue?vue&type=script&lang=js"

import "./EditSetting.vue?vue&type=style&index=0&id=969e1ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969e1ff8"]])

export default __exports__